import { render } from "../../views/chat/message_feedback.html?vue&type=template&id=8b0359bc&ts=true&external"
import script from "../../scripts/chat/message_feedback.ts?vue&type=script&lang=ts&external"
export * from "../../scripts/chat/message_feedback.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/chat/message_feedback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b0359bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b0359bc', __exports__)) {
    api.reload('8b0359bc', __exports__)
  }
  
  module.hot.accept("../../views/chat/message_feedback.html?vue&type=template&id=8b0359bc&ts=true&external", () => {
    api.rerender('8b0359bc', render)
  })

}


export default __exports__